import * as React from 'react'
import { XhprofCall } from '../xhprof/XhprofProfiler'

interface Props {
    call: string
    maxWidth?: number
}

export class FunctionCall extends React.PureComponent<Props> {
    public render = () => {
        const call = new XhprofCall(this.props.call)

        const props = this.props.maxWidth
            ? { className: 'text-ellipsis', style: { maxWidth: this.props.maxWidth, display: 'inline-block' }, title: this.props.call }
            : { className: '', title: this.props.call }

        if (!call.namespaceName) {
            return <span {...props}>{call.shortCallName}</span>
        }

        return (
            <span className="tw-line-height-20">
                <span {...props} title={call.shortCallName}>
                    {call.shortCallName}
                </span>
                {call.namespaceName ? (
                    <>
                        <br />
                        <span
                            {...props}
                            className={'text-mute tw-font-weight-normal ' + props.className}
                            title={`Namespace: ${call.namespaceName}`}
                        >
                            {call.namespaceName}
                        </span>
                    </>
                ) : null}
            </span>
        )
    }
}
